import AuthorizationHTTPAPIClient from 'frontcore/domain/authorization/data/AuthorizationHTTPAPIClient'
import AuthorizationOAuthAPIClient from 'frontcore/domain/authorization/data/AuthorizationOAuthAPIClient'
import PasswordUpdateAPIClientHTTP from 'frontcore/domain/authorization/data/PasswordUpdateAPIClientHTTP'
import {
  AuthorizationAPIClient,
  AuthorizationSSOAPIClient,
} from 'frontcore/domain/authorization/model/AuthorizationService.d'
import { AuthorizationSSOConfiguration } from 'frontcore/domain/authorization/model/types'
import { PasswordUpdateAPIClient } from 'frontcore/domain/authorization/model/usePasswordUpdate.d'

export class AuthorizationAPIClientFactory {
  static build (): AuthorizationAPIClient {
    return new AuthorizationHTTPAPIClient()
  }
}

export class AuthorizationSSOAPIClientFactory {
  static build (configuration: AuthorizationSSOConfiguration): AuthorizationSSOAPIClient {
    return new AuthorizationOAuthAPIClient(configuration)
  }
}

export class PasswordUpdateAPIClientFactory {
  static build (): PasswordUpdateAPIClient {
    return new PasswordUpdateAPIClientHTTP()
  }
}

export class AuthorizationSAMLAPIClientFactory {
  static build (): AuthorizationAPIClient {
    return new AuthorizationHTTPAPIClient()
  }
}
